define(function(require) {
	const tpl = require('./t_lov_map_view.hbs');
	const IpsModel = require('civicsBase/ipsModel');

	const map_view = require('./v_lov_site_map');
	const results_view = require('./v_lov_results_view');
	const MapUtil = require('civicsUtils/map_utilities');
	const GisSyncUtil = require('civicsUtils/gis_sync_utilities');
	const SyncModel = require('civicsModels/sync_model');
	const GisKeyCollection = require('civicsCollections/gis_key_collection');
	const ViewManager = require('civicsUtils/view_manager');

	return Marionette.LayoutView.extend({
		template: tpl,
		className: 'map-wrapper',
		events: {
			'click .showResults': 'showResultsTest',
			'click .hideResults': 'hideResults'
		},
		childEvents: {
			'siteSelected': 'siteSelected',
			'clearAllClicked':'deselectResults',
			'mapClicked':'childMapClicked'
		},
		ui: {
			mapRegion: '.map-region',
			resultsRegion: '.results-region',
			mapSearchHelper: '.map-search-helper'
		},
		regions: {
			mapRegion: '@ui.mapRegion',
			resultsRegion: '@ui.resultsRegion'
		},
		views: {},
		mapEventsEnabled: true,
		initialize: function(options) {
			this.config = options.config;
		},
		onShow: function() {
			this.views.mapView = new map_view({
				config: this.config,
				parent: this
			})
			this.mapRegion.show(this.views.mapView);
			this.ui.mapSearchHelper.show();
		},
		mapSiteSelected: function(json, model) {
			this.triggerMethod('site:added', json, model);
			if (this.mapView) {
				this.mapView.destroy();
			}
			this.destroy();
		},
		childMapClicked: function(view,features,syncData){
			this.showResults(features,syncData);
		},
		showResultsTest: function(e) {
			e.preventDefault();
			if (this.views.resultsView) {
				this.views.resultsView.destroy();
				this.resultsRegion.empty();
			}
			var jointArray = [];
			if (__DEV__) {
				jointArray = [{
					"_extensions_": 107,
					"attributes": {
						"FID": "885",
						"CURRPRCL": "Y",
						"PRCLVER": "1",
						"PRCLKEY": "1018",
						"PRCLID": "GIS-PRCL-11",
						"PRCLNAME": "GIS Parcel Test",
						"TEXT10": "GISTEST10",
						"TEXT20": "GIS Test by Elide20",
						"DATE": "1330041600000",
						"SMALL": "2013",
						"FLOAT": "2013.75",
						"DOBLE": "423993.11411",
						"LARGO": "1323993",
						"AREA": "323993.11411",
						"COMMENT": "ELIDE TEST",
						"FIREMAPNO": "2219",
						"OWNER": "CHURCH BAPTIST LIBERTY LAS VEGAS",
						"OWNER2": " ",
						"PERIMETER": "2274.88696",
						"PCLQA": "45",
						"PARCEL_UPD": "718416000000",
						"CALC_ACRES": "7.43786",
						"ASSR_ACRES": "7.47",
						"PCLBOOK": "138",
						"PCLSEC": "23",
						"PCLPAGE": "3",
						"PCLSUBD": "02",
						"PCLNO": "001",
						"TAXDIST": "200",
						"ETALFLAG": "N",
						"ADDRESS1": "6501 W LAKE MEAD BLVD",
						"ADDRESS2": "LAS VEGAS NV",
						"ADDRESS3": " ",
						"NAMETAG": "1",
						"ZIPCODE": "891087012",
						"STRNO": "6501",
						"STRDIR": "W",
						"STRNAME": "LAKE MEAD",
						"STRTYPE": "BLVD",
						"STRUNIT": "BQS1",
						"LANDUSE": "420000",
						"CAPACITY": "0",
						"ASSDYR": "2003",
						"CONSTYR": "1990",
						"DOCDATE": "19851018",
						"DOCNO": "22022161757",
						"DOCMULTI": "1",
						"DOCVEST": "F",
						"SALEPRICE": "0",
						"SALETYPE": " ",
						"SALEDATE": "000000",
						"LANDCD1": "01",
						"LANDACRE1": "7.47",
						"LANDVAL1": "326813",
						"IMPVAL": "418471",
						"TOTVAL": "745284",
						"LYLANDVAL": "326813",
						"LYIMPVAL": "418471",
						"LYTOTAL": "745284",
						"NBRHOOD": "200",
						"ADTYPE": "PM",
						"ADFILE": "0051",
						"ADPAGE": "0078",
						"ADPART": " ",
						"ADBLKCD": " ",
						"ADBLK": " ",
						"ADLOTCD": "L",
						"ADLOT": "1",
						"TOWNSHIP": "20",
						"RANGE": "60",
						"MARKAREA": "ACAB",
						"SUBNAME": "PARCEL MAP FILE 51 PAGE 78",
						"LANDADJ": "1",
						"STATEADJ": "1",
						"ZIP": "23572",
						"ASSEMBLY": "37",
						"SENATE": "03",
						"CONGRESS": "01",
						"COMMISSION": "F",
						"CENTRACT": "34.22",
						"WARD": "6",
						"PRECINCT": "6305",
						"TAZ": "346",
						"id": "885",
						"zoom": "18",
						"geometryType": "Polygon",
						"selected": 1
					},
					"geometryType": "polygon",
					"geometry": [
						[
							[-115.23749509513208,
								36.195794998172275
							],
							[-115.23579552685199,
								36.195764559989954
							],
							[-115.23579872935974,
								36.19562615798969
							],
							[-115.23579911885147,
								36.19551789601226
							],
							[-115.23580084142309,
								36.19540740270098
							],
							[-115.23580388715118,
								36.19529692224222
							],
							[-115.23580693442972,
								36.19518860488503
							],
							[-115.23580729716369,
								36.19508136128118
							],
							[-115.23580902926804,
								36.19496870489007
							],
							[-115.23580939677507,
								36.194860379746444
							],
							[-115.23580978339741,
								36.19474772845767
							],
							[-115.23581283545947,
								36.19463832054157
							],
							[-115.23581321729385,
								36.19452675078439
							],
							[-115.23581493347247,
								36.19441517588618
							],
							[-115.23581665594504,
								36.19430469156687
							],
							[-115.23581702499169,
								36.19419852951523
							],
							[-115.23581878268502,
								36.19407503965773
							],
							[-115.23593359495021,
								36.19407635533905
							],
							[-115.23606710975366,
								36.19407770714517
							],
							[-115.23620596176752,
								36.19407907428047
							],
							[-115.23633947181082,
								36.194081507318856
							],
							[-115.23647430985557,
								36.19408285349384
							],
							[-115.23661048851866,
								36.19408529396294
							],
							[-115.23674400812159,
								36.19408556347817
							],
							[-115.23688152586624,
								36.1940869259665
							],
							[-115.23701503594997,
								36.19408935825152
							],
							[-115.23714853968487,
								36.194090708819445
							],
							[-115.23728338888594,
								36.194092054115316
							],
							[-115.23741957711196,
								36.19409233059197
							],
							[-115.23759046531376,
								36.19409591574575
							],
							[-115.23758611054619,
								36.19573894842796
							],
							[-115.23758474768574,
								36.19574543378869
							],
							[-115.2375820457401,
								36.19575299683089
							],
							[-115.23757398265828,
								36.19576596114749
							],
							[-115.23756996064688,
								36.19577027572751
							],
							[-115.23755523066558,
								36.195782139234595
							],
							[-115.23754987903803,
								36.195785377436266
							],
							[-115.23752982914495,
								36.19579073627432
							],
							[-115.2374964342189,
								36.19579392049175
							],
							[-115.23749509513208,
								36.195794998172275
							]
						]
					]
				}, {
					"_extensions_": 119,
					"attributes": {
						"FID": "15",
						"CURRADDR": "Y",
						"VERSION": "1",
						"ADDRKEY": "0",
						"AddrType": "A",
						"STRNO": "7452",
						"STRDIR": " ",
						"STRNAME": "STONEY SHORE",
						"PostDir1": " ",
						"STRTYPE": "DR",
						"SubDesign": " ",
						"CITY": "Las Vegas",
						"STATE": "NV",
						"ZIP": " ",
						"PreDir2": " ",
						"StName2": " ",
						"PostDir2": " ",
						"Suffix2": " ",
						"PreDir3": " ",
						"StName3": " ",
						"PostDir3": " ",
						"Suffix3": " ",
						"ToStNo": " ",
						"Compass": " ",
						"POINT_X": "752889.032768",
						"POINT_Y": "26772443.6846",
						"OWNER": "MAHATHEY WILLIAM E & MICHELLE D",
						"MAPNO": "GIS MapNo",
						"COMMENT": "ELIDE TEST",
						"TEXT10": "MyTest",
						"TEXT20": "GIS TEST20 CARACTERS",
						"DATE": "1267056000000",
						"SMALL": "2013",
						"FLOAT": "2.01368",
						"DOBLE": "2013.12345",
						"LARGO": "20131101",
						"AREA": "9847.55799",
						"PARCEL_UPD": "717811200000",
						"CALC_ACRES": "0.22607",
						"PERIMETER": "415.06095",
						"TOTVAL": "61079",
						"PARCEL": "13822310015",
						"URL": "http://binged.it/120jdyN",
						"PARCELID": "13822310015",
						"id": "15",
						"zoom": "19",
						"geometryType": "Point",
						"selected": 1
					},
					"geometryType": "point",
					"geometry": [-115.25553541065369,
						36.19411918521281
					]
				}, {
					"_extensions_": 124,
					"attributes": {
						"FID": "20",
						"CURRPRCL": "Y",
						"PRCLVER": "1",
						"PRCLKEY": "0",
						"PRCLID": "13822310015",
						"PRCLNAME": "GIS Parcel Test",
						"TEXT10": "GISTEST10",
						"TEXT20": "GIS Test by Elide20",
						"DATE": "1330041600000",
						"SMALL": "2013",
						"FLOAT": "2013.75",
						"DOBLE": "109847.55799",
						"LARGO": "1009848",
						"AREA": "9847.55799",
						"COMMENT": "ELIDE TEST",
						"FIREMAPNO": "2218",
						"OWNER": "MAHATHEY WILLIAM E & MICHELLE D",
						"OWNER2": " ",
						"PERIMETER": "415.06095",
						"PCLQA": "36",
						"PARCEL_UPD": "717811200000",
						"CALC_ACRES": "0.22607",
						"ASSR_ACRES": "0",
						"PCLBOOK": "138",
						"PCLSEC": "22",
						"PCLPAGE": "3",
						"PCLSUBD": "10",
						"PCLNO": "015",
						"TAXDIST": "200",
						"ETALFLAG": "N",
						"ADDRESS1": "7452 STONEY SHORE DR",
						"ADDRESS2": "LAS VEGAS NV",
						"ADDRESS3": " ",
						"NAMETAG": "1",
						"ZIPCODE": "891283004",
						"STRNO": "7452",
						"STRDIR": " ",
						"STRNAME": "STONEY SHORE",
						"STRTYPE": "DR",
						"STRUNIT": "BQS1",
						"LANDUSE": "110001",
						"CAPACITY": "1",
						"ASSDYR": "2003",
						"CONSTYR": "1993",
						"DOCDATE": "19930819",
						"DOCNO": "1993081900454",
						"DOCMULTI": "1",
						"DOCVEST": "A",
						"SALEPRICE": "127900",
						"SALETYPE": "Z",
						"SALEDATE": "199308",
						"LANDCD1": "02",
						"LANDACRE1": "0",
						"LANDVAL1": "12250",
						"IMPVAL": "48829",
						"TOTVAL": "61079",
						"LYLANDVAL": "12250",
						"LYIMPVAL": "48829",
						"LYTOTAL": "61079",
						"NBRHOOD": "200",
						"ADTYPE": "PB",
						"ADFILE": "0048",
						"ADPAGE": "0045",
						"ADPART": " ",
						"ADBLKCD": "B",
						"ADBLK": "B",
						"ADLOTCD": "L",
						"ADLOT": "77",
						"TOWNSHIP": "20",
						"RANGE": "60",
						"MARKAREA": "BAAC",
						"SUBNAME": "TENAYA WEST #1A BY LEWIS HOMES",
						"LANDADJ": "1",
						"STATEADJ": "1",
						"ZIP": "23592",
						"ASSEMBLY": "37",
						"SENATE": "06",
						"CONGRESS": "01",
						"COMMISSION": "B",
						"CENTRACT": "34.21",
						"WARD": "4",
						"PRECINCT": "2314",
						"TAZ": "343",
						"id": "20",
						"zoom": "19",
						"geometryType": "Polygon"
					},
					"geometryType": "polygon",
					"geometry": [
						[
							[-115.2554986643062,
								36.19427366460137
							],
							[-115.25529008702392,
								36.19398854624754
							],
							[-115.25529410559874,
								36.19398746669731
							],
							[-115.25529677420322,
								36.19398747401067
							],
							[-115.25529811301669,
								36.19398639612919
							],
							[-115.25530078613232,
								36.19398532190442
							],
							[-115.25530346375908,
								36.193983166141436
							],
							[-115.25531014884078,
								36.19397993079707
							],
							[-115.25531417639935,
								36.193976697182705
							],
							[-115.25531684951443,
								36.19397562295751
							],
							[-115.25532220480387,
								36.19397130241789
							],
							[-115.25532621673145,
								36.19396915031079
							],
							[-115.25533961605188,
								36.19395835349711
							],
							[-115.25534229818732,
								36.1939551161951
							],
							[-115.25534765347395,
								36.193950795654345
							],
							[-115.25534899679668,
								36.19394863623417
							],
							[-115.25535301323289,
								36.193945402587985
							],
							[-115.25535703872724,
								36.19393999685262
							],
							[-115.25536105516271,
								36.193936763206125
							],
							[-115.25536776939839,
								36.193929201736466
							],
							[-115.25537045604189,
								36.19392488289563
							],
							[-115.25573435779131,
								36.19409564677321
							], [-115.25574036333713,
								36.19427422719052
							], [-115.2554986643062,
								36.19427366460137
							]]]
							}, {
								"_extensions_": 82,
								"attributes": {
									"lon": "-115.2646922542161",
									"lat": "36.193099605773085",
									"zoom": "13",
									"geometryType": "Point",
									"selected": 1
								},
								"geometryType": "point",
								"geometry": [-115.26469225421609,
									36.19309960577307
								]
							}]
							}
							this.showResults(jointArray, []);
		},
		showResults: function(jointArray, syncData) {
			var self = this;

			ViewManager.loading(true);

			if (this.views.resultsView) {
				this.views.resultsView.destroy();
				this.resultsRegion.empty();
			}

			var syncData = [];
			var gisToIpsMapping = {};

			var syncModelsPromise = $.Deferred();
			var gisKeysPromise = $.Deferred();

			$.when.apply($,syncData.map(data=>data.fetch())).then(function(){
				GisSyncUtil.saveSyncDataToSessionStorage(syncData);
				syncModelsPromise.resolve();
			},function() {
				ViewManager.loading(false);
				ViewManager.openAlert(i18n.t('CIVICS.COMMON.GIS_SYNC_ERROR'));
			});


			$.when(syncModelsPromise).done(function(){
				var gisKeyMappings = [];

				$.each(jointArray,function(index,el){
					if(el.attributes){
						if((el.attributes.syncEventType=='address' && (el.attributes.ADDRKEY==undefined || el.attributes.ADDRKEY < 1))
									|| (el.attributes.syncEventType=='parcel' && (el.attributes.PRCLKEY==undefined || el.attributes.PRCLKEY < 1)) ){
							//if we can't find an address key or parcel key, try to get the key from sync
							var mappings = GisSyncUtil.getGisKeyFromMapping(el.attributes);
							if(mappings && mappings.gisKey) {
									gisKeyMappings.push(mappings);
									el.attributes.gisKey = mappings.gisKey;
									el.attributes.hasSyncKey = true;
									el.attributes.syncMappingId = mappings.syncMapping;
							}
						}


					}
				}.bind(this));

				// If there are no mappings, no need to make the next call
				if(gisKeyMappings.length == 0) {
					gisKeysPromise.resolve();
					return;
				}

				var gisKeyModel = new GisKeyCollection();

				gisKeyModel.fetch({
					'type': 'POST',
					'contentType': 'application/json',
					'data': JSON.stringify({'GisKeys': gisKeyMappings}),
					'success': function(){
						gisToIpsMapping = GisSyncUtil.mapSyncKeys(gisKeyModel);
						gisKeysPromise.resolve();
					},
					'error': function(){
						ViewManager.loading(false);
						ViewManager.openAlert(i18n.t('CIVICS.COMMON.GIS_SYNC_ERROR'));
					},
				});

			});

			$.when(gisKeysPromise).done(function(){
					this.featureColl = new Backbone.Collection();
				// disable the parcel/address if it isn't in IPS
					_.forEach(jointArray,model=>{
						if(model.attributes.gisKey !=null) {
							if(model.attributes.syncMappingId) {
								var mappingKey = model.attributes.gisKey +'-'+model.attributes.syncMappingId;
						} else {
								var mappingKey = model.attributes.gisKey;
						}

							if(gisToIpsMapping[mappingKey] != null && model.attributes.hasSyncKey ) {
								if(model.attributes.syncEventType =='parcel') {
									model.attributes.PRCLKEY = parseInt(gisToIpsMapping[mappingKey]);
								} else if (model.attributes.syncEventType =='address') {
									model.attributes.ADDRKEY = parseInt(gisToIpsMapping[mappingKey]);
							}
						}
					}

						model =  MapUtil.processMapModel(model.attributes);
						this.featureColl.add(model);
					});

				ViewManager.loading(false);

				this.views.resultsView = new results_view({
					config: this.config,
					collection: this.featureColl,
					inMapView:true
				});
				this.resultsRegion.show(this.views.resultsView);
				this.$el.addClass('show-results');
				window.setTimeout(function() {
				window.dispatchEvent(new Event('resize'));
				}, 10);

			}.bind(this));
		},
		deselectResults: function(e) {
			$('input[name="additionalSites"]').prop('checked', false);
		},
		hideResults: function(e) {
			if(e.preventDefault){
				e.preventDefault();
			}
			this.$el.removeClass('show-results');
			window.setTimeout(function() {
				window.dispatchEvent(new Event('resize'));
			}, 10)
		},
		siteSelected: function(childView, selectedSiteID, description, model) {
			//console.log('SITE INFO ', selectedSiteID, description, model);
			this.triggerMethod('siteSelected2', selectedSiteID, description, model);
		},
		templateHelpers: function() {
			var self = this;
			return {
				dev:__DEV__
			}
		}
	});
});
